var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInflexionLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01084 24.4478C5.01084 22.4716 5.79589 20.5763 7.19328 19.1789C8.59068 17.7815 10.486 16.9965 12.4622 16.9965V24.4478H24.3843V0.603516C24.3843 3.76546 23.1282 6.7979 20.8924 9.03374C18.6566 11.2696 15.6241 12.5257 12.4622 12.5257C9.30023 12.5257 6.26779 13.7817 4.03195 16.0176C1.79612 18.2534 0.540039 21.2858 0.540039 24.4478H5.01084Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9135 0.603516H12.4622V8.05485C14.4384 8.05485 16.3337 7.2698 17.731 5.87241C19.1284 4.47501 19.9135 2.57973 19.9135 0.603516Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInflexionLogoBlack);
export default __webpack_public_path__ + "static/media/inflexion-logo-black.2750217ab69ac20f9393b30347854594.svg";
export { ForwardRef as ReactComponent };